import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const AnnouncementsList = loadable(() => pMinDelay(import('./AnnouncementsList'), 300), {
  fallback: <Loading />
});

const AsyncAnnouncementsList = props => {
  const pageConfig = {
    headerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-white hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <AnnouncementsList { ...props } helmet={ pageConfig.helmet } />
    </ApplicationLayout>
  );
};

AsyncAnnouncementsList.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncAnnouncementsList;
